<template>
  <div
    v-if="appReady && firstLoadDone"
    id="wrapper-content-base"
    class="wrapper-content-base"
    :class="{
      'text-unselectable': isMobile,
      authenticated: isAuthenticated,
      'trial-banner-open': trialBannerOpen && !isMobile,
      active: searchBottomBarActive
    }"
  >
    <MAnimatedCheckbox
      v-if="coverageConfirmVisible"
      :show-animation="addCoverageCode == 200"
      class="confirm-box"
      @close="coverageConfirmVisible = false"
    >
      <div class="flex-center mgb-25">
        <svg
          width="50"
          height="50"
          viewBox="0 0 50 50"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0 8.125C0 5.97012 0.856024 3.90349 2.37976 2.37976C3.90349 0.856024 5.97012 0 8.125 0H34.375C36.5299 0 38.5965 0.856024 40.1202 2.37976C41.644 3.90349 42.5 5.97012 42.5 8.125V20.0175C42.2919 20.0056 42.0835 19.9998 41.875 20H38.75V8.125C38.75 6.96468 38.2891 5.85188 37.4686 5.03141C36.6481 4.21094 35.5353 3.75 34.375 3.75H8.125C6.96468 3.75 5.85188 4.21094 5.03141 5.03141C4.21094 5.85188 3.75 6.96468 3.75 8.125V36.875C3.75 39.29 5.71 41.25 8.125 41.25H10V41.875C10 42.9625 10.1625 44.0125 10.4675 45H8.125C5.97012 45 3.90349 44.144 2.37976 42.6202C0.856024 41.0965 0 39.0299 0 36.875V8.125ZM11.875 7.5C11.3777 7.5 10.9008 7.69754 10.5492 8.04917C10.1975 8.40081 10 8.87772 10 9.375C10 9.87228 10.1975 10.3492 10.5492 10.7008C10.9008 11.0525 11.3777 11.25 11.875 11.25H30.625C31.1223 11.25 31.5992 11.0525 31.9508 10.7008C32.3025 10.3492 32.5 9.87228 32.5 9.375C32.5 8.87772 32.3025 8.40081 31.9508 8.04917C31.5992 7.69754 31.1223 7.5 30.625 7.5H11.875ZM15 15.625C15 15.1277 15.1975 14.6508 15.5492 14.2992C15.9008 13.9475 16.3777 13.75 16.875 13.75H30.625C31.1223 13.75 31.5992 13.9475 31.9508 14.2992C32.3025 14.6508 32.5 15.1277 32.5 15.625C32.5 16.1223 32.3025 16.5992 31.9508 16.9508C31.5992 17.3025 31.1223 17.5 30.625 17.5H16.875C16.3777 17.5 15.9008 17.3025 15.5492 16.9508C15.1975 16.5992 15 16.1223 15 15.625ZM12.5 30.625C12.5 28.4701 13.356 26.4035 14.8798 24.8798C16.4035 23.356 18.4701 22.5 20.625 22.5H41.875C42.942 22.5 43.9985 22.7102 44.9843 23.1185C45.9701 23.5268 46.8658 24.1253 47.6202 24.8798C48.3747 25.6342 48.9732 26.5299 49.3815 27.5157C49.7898 28.5015 50 29.558 50 30.625V41.875C50 42.942 49.7898 43.9985 49.3815 44.9843C48.9732 45.9701 48.3747 46.8658 47.6202 47.6202C46.8658 48.3747 45.9701 48.9732 44.9843 49.3815C43.9985 49.7898 42.942 50 41.875 50H20.625C19.558 50 18.5015 49.7898 17.5157 49.3815C16.5299 48.9732 15.6342 48.3747 14.8798 47.6202C14.1253 46.8658 13.5268 45.9701 13.1185 44.9843C12.7102 43.9985 12.5 42.942 12.5 41.875V30.625ZM20.625 26.25C19.365 26.25 18.2275 26.7825 17.43 27.6375L31.25 36.52L45.07 27.6375C44.6613 27.1992 44.1667 26.8498 43.617 26.611C43.0673 26.3723 42.4743 26.2494 41.875 26.25H20.625ZM16.25 41.875C16.25 44.29 18.21 46.25 20.625 46.25H41.875C43.0353 46.25 44.1481 45.7891 44.9686 44.9686C45.7891 44.1481 46.25 43.0353 46.25 41.875V31.335L32.265 40.3275C31.9623 40.5224 31.61 40.626 31.25 40.626C30.89 40.626 30.5377 40.5224 30.235 40.3275L16.25 31.335V41.875Z"
            fill="#409FFF"
          />
        </svg>
      </div>

      <p class="text-center mgb-25">
        <strong>
          {{ $t('search_create_coverage_info') }}
        </strong>
      </p>

      <AButton
        v-if="addCoverageCode != 200"
        :loading="addingCoverage"
        class="is-rounded is-secondary"
        @click="handleAddCoverage()"
        >{{ $t('search_create_coverage_button') }}</AButton
      >

      <p v-if="addCoverageCode == 409" class="text-danger mgt-10">
        {{ $t('search_coverage_already_exists') }}
      </p>
    </MAnimatedCheckbox>

    <aside
      v-if="isFilterVisible || !isMobile"
      class="column"
      :class="{
        left: !isMobile,
        'full-panel': isMobile,
        authenticated: isAuthenticated
      }"
    >
      <OSearchFilters @search="handleSearch($event)" />

      <div
        v-if="isMobile"
        class="filter-panel-bar"
        :class="{ authenticated: isAuthenticated }"
      >
        <AButton
          :is-loading="isSearching || !mapReady"
          :is-rounded="true"
          :is-large="true"
          :is-fullwidth="true"
          @click="hideFilters"
        >
          <span v-if="isMobile">
            {{
              $t('search_showing_result_button', {
                totalItems: numberOfResults
              })
            }}</span
          >
        </AButton>
      </div>
    </aside>
    <transition v-if="isMapOutOfViewPort && isMobile" name="scale" appear>
      <div class="show-map-wrapper" :class="{ authenticated: isAuthenticated }">
        <AButton
          :is-small="true"
          :is-rounded="true"
          :hover-effect="false"
          @click="setBodyActive(false)"
        >
          <span class="icon-wrapper-left">
            <AImage :url="icons.GENERAL.MAP" :classes="['icon']"
          /></span>
          {{ $t('general_map') }}
        </AButton>
      </div>
    </transition>
    <div
      v-show="!isFilterVisible || !isMobile"
      id="results"
      class="middle results-wrapper"
      :class="[
        currentListViewMode,
        { authenticated: isAuthenticated },
        { column: !isMobile },
        {
          tabBarVisible:
            isAuthenticated && appReady && showMobileTabbar && !isAppRequest
        }
      ]"
      @touchmove="setBodyActive(true)"
    >
      <section v-if="searchViewVisible" class="results">
        <AViewPort
          v-if="isMobile"
          mode="in"
          :offset="0"
          :stop="false"
          @change="isMapOutOfViewPort = false"
        />

        <AViewPort
          v-if="isMobile"
          mode="under"
          :offset="0"
          :stop="false"
          @change="isMapOutOfViewPort = true"
        />

        <div v-if="isMobile" id="drag-panel-top" class="drag-panel-top">
          <div class="drag-panel-top-icon">
            <svg
              width="50"
              height="4"
              viewBox="0 0 50 4"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M0 2C0 0.895431 0.89543 0 2 0H25H48C49.1046 0 50 0.895431 50 2V2C50 3.10457 49.1046 4 48 4H25H2C0.89543 4 0 3.10457 0 2V2Z"
                fill="#C4C4C4"
              />
            </svg>
          </div>

          <h2 class="drag-panel-top-title">
            {{ resultText }}
          </h2>
        </div>

        <div v-show="!isMobile && activeFilterKeys.length > 0" class="mgb-25">
          <MSearchFilterBar @search="handleFilterBarSearch"></MSearchFilterBar>
        </div>

        <div class="search-info-box">
          <h2 v-if="!isMobile" class="mgb-25">
            {{ resultText }}
          </h2>

          <div class="mgb-25">
            <MSearchBoxButtons
              :adding="addingCoverage"
              @createCoverage="createCoverageClick()"
              @goToCoverages="setSearchViewVisible(false)"
            ></MSearchBoxButtons>
          </div>
          <div class="row">
            <AToggleChoice
              :active="{
                icon: isMobile
                  ? icons.GENERAL.LIST_SMALL
                  : icons.GENERAL.LIST_BIG
              }"
              :inactive="{
                icon: isMobile
                  ? icons.GENERAL.LIST_BIG
                  : icons.GENERAL.LIST_SMALL
              }"
              :is-active="listViewSwitcherActive"
              :is-rounded="true"
              :button="false"
              :wrapper-all-classes="['view-selector-all-wrapper']"
              :wrapper-classes="['view-selector-wrapper']"
              @change="handleListViewSwitch($event)"
            />

            <div class="flex-center">
              <div class="select-wrapper">
                <select
                  id="order"
                  name="order"
                  :value="orderValue"
                  @change="handleOrder($event.target.value)"
                >
                  <option value="">{{ $t('search_order_select_1') }}</option>
                  <option value="rent_asc">
                    {{ $t('search_order_select_2') }}
                  </option>
                  <option value="rent">
                    {{ $t('search_order_select_3') }}
                  </option>
                  <option value="rooms">
                    {{ $t('search_order_select_4') }}
                  </option>
                  <option value="sqm">
                    {{ $t('search_order_select_5') }}
                  </option>
                  <option value="propositionNo">
                    {{ $t('search_order_select_6') }}
                  </option>
                </select>
              </div>
            </div>

            <span
              v-if="isMobile"
              class="filter-toggle-button"
              @click="handleFiltersClick"
            >
              <AImage :url="icons.FILTER.FILTERS" :classes="['icon']"
            /></span>
          </div>
        </div>

        <div
          v-if="data && data.results && data.results.length > 0"
          class="search-results"
        >
          <div
            v-for="(item, index) in data.results"
            :key="index + item.propositionNo + item.propositionId"
          >
            <MSearchListItem
              :is-loading="isSearching"
              :item="item"
              :mode="currentListViewMode"
              :marked="markedItemId === item.pointId"
              @like="handleLike()"
              @mouseenter="handleHover(item)"
              @mouseleave="handleHover(null)"
              @click="handlePropositionClick($event)"
              @click.right.native="handlePropositionCardRightClick($event)"
            />

            <SponsoredPropositions
              v-if="
                $country.isFeatureEnabled('EXTRA_VISIBILITY') &&
                sponsoredPropositions.length &&
                index === sponsoredPropositionsPosition
              "
              :propositions="sponsoredPropositions"
              :title="$t('proposition_extra_visibility_title')"
              :flexible="true"
              class="sponsored-propositions"
            />
          </div>

          <AViewPort
            v-if="
              !isLoading &&
              mapReady &&
              data !== null &&
              nextPageExists &&
              ((isMobile && !isFilterVisible) || !isMobile)
            "
            mode="in"
            :offset="0"
            @change="loadNextPage()"
          />

          <router-link
            v-if="!isLoadingNextPage && nextPageExists"
            id="next-button"
            :to="nextPageUrl"
            class="pulled-right"
            >{{ $t('search_next_page') }}
          </router-link>

          <div class="large-page-spinner-wrapper">
            <div class="spinner">
              <a-spinner
                v-if="isLoadingNextPage"
                :classes="['next-page-spinner']"
              />
            </div>
          </div>
        </div>
        <p
          v-if="!isLoading && mapReady && (numberOfResults === 0 || !data)"
          class="no-hits"
        >
          <b
            ><i>{{ $t('search_no_hits') }}.</i></b
          >
        </p>
      </section>

      <section v-else class="results margin-bottom-fix">
        <h2 class="title">
          {{ $t('search_coverage_manage_title') }}
        </h2>

        <div v-if="isLoadingCoverage" class="large-page-spinner-wrapper">
          <div class="spinner">
            <a-spinner :classes="['next-page-spinner']" />
          </div>
        </div>

        <div v-if="numberOfCoverageResults > 0">
          <transition-group name="fade-list" appear>
            <MCoverageListItem
              v-for="(item, index) in coverageData.results"
              :key="index + item.id"
              :item="item"
              :deleting="deletingCoverage"
              @search="handleCoverageClick($event)"
              @delete="handleDeleteCoverage($event.id)"
            />
          </transition-group>
        </div>

        <p
          v-if="
            !isLoadingCoverage &&
            numberOfCoverageResults === 0 &&
            isAuthenticated
          "
          class="no-hits"
        >
          <b
            ><i>{{ $t('search_coverage_empty') }}.</i></b
          >
        </p>

        <MSearchLoginBox v-if="!isAuthenticated && !searchViewVisible">
        </MSearchLoginBox>

        <div class="search-coverage-close">
          <AButton
            :is-rounded="true"
            :is-large="true"
            class="search-coverage-close-button"
            @click="setSearchViewVisible(true)"
            >{{ $t('search_coverage_close_view') }}</AButton
          >
        </div>
      </section>
    </div>

    <!-- RIGHT -->
    <section
      v-show="searchViewVisible || !isMobile"
      class="column right relative"
    >
      <MSearchMap
        ref="mSearchMap"
        :is-searching="isSearching"
        :highlighted-marker-id="highlightedMarkerPointId"
        :root-filter="rootFilter"
        :is-authenticated="isAuthenticated"
        :full-screen-mode="isMobile"
        @created="handleMapReady($event)"
        @search="handleSearch({ ...$event, skipBoundingBoxAlign: true })"
        @filter="setFilter($event)"
        @rootFilter="setRootFilter($event)"
        @movestart="hideMapCard()"
        @markerEnter="handleMarkerHover($event)"
        @markerLeave="markedItemId = null"
        @click="!$event ? hideMapCard() : handleMarkerClicked($event)"
        @touchstart="setBodyActive(false)"
      >
        <div
          v-if="isMobile"
          :class="[
            'geolocation-wrapper-mobile',
            { 'is-fixed': fixedSearchMapMobile }
          ]"
        >
          <OGeolocation
            :value="geolocationValue"
            :is-multiple="false"
            :freetext-enabled="isTypeResidence"
            :max-results="4"
            :hide-type="true"
            :icon="icons.GENERAL.ARROW_RIGHT_ALT"
            :placeholder="
              $t(
                isTypeResidence
                  ? 'search_filters_placeholder_1'
                  : 'search_wish_area_placeholder'
              )
            "
            @click="hideMapCard()"
            @input="searchSpecificArea($event)"
          >
            <span
              v-if="isMobile"
              class="icon-wrapper clickable"
              @click="handleFiltersClick"
            >
              <AImage :url="icons.FILTER.FILTERS" :classes="['icon']"
            /></span>
            <span
              v-if="isMobile && activeFilterKeys.length > 0"
              class="filter-info-wrapper"
              @click="handleFiltersClick"
            >
              <span class="filter-info clickable">{{
                activeFilterKeys.length
              }}</span>
            </span>
          </OGeolocation>
        </div>
      </MSearchMap>

      <transition v-if="showMapCardModal" name="scale" appear>
        <div
          v-outside-click="hideMapCard"
          :class="[
            'map-card-item',
            { 'map-card-item-with-controls': currentMapCardIds.length > 1 }
          ]"
        >
          <!-- <div v-if="mapCardItemLoading" class="spinner-wrapper">
            <ASpinner></ASpinner>
          </div> -->
          <MSearchListItem
            v-if="mapCardItem"
            :is-loading="isSearching"
            :item="mapCardItem"
            :is-part-of-list="false"
            mode="card-mobile"
            @like="handleLike()"
            @likeDone="handleLikeDone($event)"
            @click="handlePropositionClick($event)"
            @click.right.native="handlePropositionCardRightClick($event, true)"
          />
          <div
            v-if="currentMapCardIds.length > 1"
            class="map-card-item-controls"
          >
            <button
              class="map-card-item-button point-left"
              aria-label="Previous"
              @click="showPreviousMapCard()"
            >
              <span></span>
            </button>
            <span class="map-card-item-controls-text">
              {{
                $t('search_card_item_controls', {
                  from: currentMapCardIndex + 1,
                  to: currentMapCardIds.length
                })
              }}
            </span>
            <button
              class="map-card-item-button point-right"
              aria-label="Next"
              @click="showNextMapCard()"
            >
              <span></span>
            </button>
          </div>
        </div>
      </transition>
    </section>

    <MSearchLoginBox
      v-if="!isAuthenticated && loginConverterVisible"
      class="confirm-box"
      :overlay="true"
      @close.prevent.stop="hideLoginbox"
    >
      <strong>{{ loginConverterMessage }}.</strong></MSearchLoginBox
    >
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations, mapState } from 'vuex';
import { toggleArrayItem } from '@/utils/helpers/array';
import { scrollToElement } from '@/utils/helpers/dom';
import outsideClick from '@/directives/outside-click';
import { searchTypes } from '../../../models/search-filter';
import icons from '@/utils/icon-constants';
import { convertToSearchFilter } from '../../../models/search-filter';

import MSearchListItem from '@/components/atomic/molecules/m-search-list-item';
import MSearchFilterBar from '@/components/atomic/molecules/m-search-filter-bar';

import AButton from '@/components/atomic/atoms/a-button';

import AViewPort from '@/components/atomic/atoms/a-viewport';
import OSearchFilters from '@/components/atomic/organisms/o-search-filters';
import ASpinner from '@/components/atomic/atoms/a-spinner';

import MCoverageListItem from '@/components/atomic/molecules/m-search-coverage-list-item';
import MSearchBoxButtons from '@/components/atomic/molecules/m-search-box-buttons';
import MSearchLoginBox from '@/components/atomic/molecules/m-search-login-box';
import MAnimatedCheckbox from '@/components/atomic/molecules/m-animated-checkbox-box';

import AToggleChoice from '@/components/atomic/atoms/a-toggle-choice';
import MSearchMap from '@/components/atomic/molecules/m-search-map';

import OGeolocation from '@/components/atomic/organisms/o-geolocation';

import AImage from '@/components/atomic/atoms/a-image';

import SponsoredPropositions from '@/components/SponsoredPropositions/SponsoredPropositions';
import events from '@/utils/helpers/events';
import i18n from '@/i18n';
import { addRightClickTracker } from '@/utils/helpers/rightClick';

import {
  getRelatedLocalities,
  getSearchProposition
} from '../../../store/modules/search/services';

export default {
  components: {
    MSearchListItem,
    AButton,
    OSearchFilters,
    AViewPort,
    ASpinner,
    MCoverageListItem,
    MSearchBoxButtons,
    MSearchLoginBox,
    MAnimatedCheckbox,
    MSearchFilterBar,
    AToggleChoice,
    MSearchMap,
    OGeolocation,
    AImage,
    SponsoredPropositions
  },
  directives: {
    outsideClick
  },
  data() {
    return {
      isSearching: false,
      isLoadingNextPage: false,
      deletingCoverage: false,
      searchViewVisible: true,
      coverageConfirmVisible: false,
      addCoverageCode: 0,
      addingCoverage: false,
      firstLoadDone: false,
      headVisible: false,
      searchingTimerId: null,
      listViewSwitcherActive: false,
      icons: icons,
      loginConverterVisible: false,
      loginConverterMessage: '',
      searchAfterMapMovement: false,
      mapReady: false,
      highlightedMarkerPointId: null,
      isFilterVisible: false,
      searchTypes,
      markedItemId: null,
      isIosDevice: false,
      mapCardItem: null,
      mapCardItemLoading: false,
      searchOrder: '',
      isMapOutOfViewPort: false,
      isFirstSearchDone: false,
      windowTop: 0,
      currentMapCardIds: [],
      currentMapCardIndex: 0,
      showMapCardModal: false
    };
  },
  head: {
    link() {
      const links = [];

      links.push({
        rel: 'next',
        href: `${i18n.t('path_search')}?page=${this.getNextPageNumber()}`
      });

      if (this.getNextPageNumber() > 2)
        links.push({
          rel: 'prev',
          href: `${i18n.t('path_search')}?page=${this.getPrevPageNumber()}`
        });

      return links;
    }
  },
  computed: {
    ...mapState('search', ['searchBottomBarActive']),
    showMobileTabbar() {
      const shouldShow = this.isMobile && this.tabBarVisible;
      return shouldShow;
    },
    fixedSearchMapMobile() {
      return this.windowTop > 60;
    },

    isTypeResidence() {
      return this.rootFilter.type === this.searchTypes.RESIDENCE;
    },

    orderValue() {
      if (this.rootFilter.orderBy && this.rootFilter.orderBy.length > 0) {
        const order = this.rootFilter.orderBy[0];
        return `${order.key}${!order.desc ? '_asc' : ''}`;
      }

      return '';
    },

    nextPageExists() {
      return this.data.meta.numPages > this.data.meta.page;
    },

    nextPageUrl() {
      const path = this.$router.currentRoute.path;
      const query = this.$router.currentRoute.query;
      let newPath = `${path}?`;

      if (!query.page) newPath += `page=${this.getNextPageNumber()}`;
      else newPath += 'page=' + this.getNextPageNumber();

      if (query.filter) newPath += '&filter=' + query.filter;

      return newPath;
    },

    geolocationsSourceShort() {
      const index = this.filter.geolocationsSource?.indexOf(',');
      if (index > -1) {
        return this.filter.geolocationsSource.substring(0, index);
      }
      return this.filter.geolocationsSource;
    },

    filterPanelAnimation() {
      if (this.isMobile) return 'slide-up';

      return null;
    },

    geolocationValue() {
      if (this.filter.freetext) {
        return this.filter.freetext;
      } else if (!this.isTypeResidence) {
        return this.filter.geolocationsSource;
      } else {
        return this.filter.geolocations;
      }
    },

    isOrderActive() {
      return order =>
        this.rootFilter &&
        this.rootFilter.orderBy &&
        this.rootFilter.orderBy.some(x => x.key == order);
    },

    resultText() {
      if (!this.mapReady || (this.isLoading && !this.isFirstSearchDone)) {
        return this.$t('swap_view_loading', this.$routeLocale);
      } else if (this.filter.geolocations.length > 0) {
        let locationName = this.filter.geolocationsSource;

        if (this.filter.geolocationsSource) {
          locationName = this.geolocationsSourceShort;
        }

        if (this.isTypeResidence) {
          return this.$t('search_showing_x_items_location', {
            totalItems: this.numberOfResults,
            locationName: locationName,
            locale: this.$routeLocale
          });
        } else {
          return this.$t('search_showing_x_items_location_wish', {
            totalItems: this.numberOfResults,
            locationName: locationName,
            locale: this.$routeLocale
          });
        }
      } else if (this.filter.freetext) {
        return this.$t('search_showing_x_items_freetext', {
          totalItems: this.numberOfResults,
          freetext: this.filter.freetext,
          locale: this.$routeLocale
        });
      } else if (!this.filter.freetext && this.rootFilter.searchArea) {
        return this.$t('search_showing_x_items_map', {
          totalItems: this.numberOfResults,
          locale: this.$routeLocale
        });
      } else if (this.activeFilterKeys.length) {
        return this.$t('search_showing_x_items_all', {
          totalItems: this.numberOfResults,
          locale: this.$routeLocale
        });
      } else {
        return this.$t('search_showing_x_items_total', {
          totalItems: this.totalNumberOfAds,
          locale: this.$routeLocale
        });
      }
    },

    numberOfCoverageResults() {
      if (this.coverageData && this.coverageData.results)
        return this.coverageData.results.length;

      return 0;
    },

    numberOfResults() {
      if (this.data && this.data.meta)
        return this.data.meta.numResults.toLocaleString();

      return 0;
    },

    totalNumberOfAds() {
      if (this.data && this.data.meta)
        return this.data.meta.totalCount.toLocaleString();

      return 0;
    },

    currentListViewMode() {
      if (!this.searchViewVisible) return 'coverage';
      else if (!this.isMobile && this.listViewSwitcherActive)
        return 'card-desktop';
      else if (!this.isMobile && !this.listViewSwitcherActive)
        return 'list-desktop';
      else if (this.isMobile && this.listViewSwitcherActive)
        return 'list-mobile';
      else if (this.isMobile && !this.listViewSwitcherActive)
        return 'card-mobile';
      return 'list-desktop';
    },

    sponsoredPropositionsPosition() {
      if (this.currentListViewMode === 'list-desktop') {
        return 7;
      } else {
        return 2;
      }
    },

    // mappedSponsoredPropositions() {
    //   if (!this.sponsoredPropositions) return [];

    //   return this.sponsoredPropositions
    //     .filter(x => x)
    //     .map(proposition => {
    //       const newProposition = {
    //         ...proposition,
    //         residences: [
    //           {
    //             ...proposition.residences[0],
    //             pictures: [proposition.extraVisibilityFileName]
    //           }
    //         ]
    //       };
    //       return newProposition;
    //     });
    // },

    ...mapGetters({
      isLoadingCoverage: 'search/isLoadingCoverage',
      isLoading: 'search/isLoading',
      data: 'search/data',
      filter: 'search/filter',
      rootFilter: 'search/rootFilter',
      activeFilterKeys: 'search/activeFilterKeys',
      appReady: 'app/ready',
      isAuthenticated: 'app/isAuthenticated',
      isMobile: 'screenSize/isMobile',
      isSmallDesktop: 'screenSize/isSmallDesktop',
      coverageData: 'search/coverageData',
      trialBannerOpen: 'trial/trialBannerOpen',
      sponsoredPropositions: 'propositions/sponsoredPropositions',
      tabBarVisible: 'menu/tabBarVisible',
      isAppRequest: 'app/isAppRequest'
    })
  },

  watch: {
    isLoading(newVal) {
      if (!newVal) {
        window.prerenderPaused = false;
      }
    },

    '$route.query.page'(newVal, oldVal) {
      if (oldVal !== newVal) this.handleSearch();
    },
    async currentMapCardIndex(newVal, oldVal) {
      if (newVal !== oldVal) {
        const propositionId = this.currentMapCardIds[this.currentMapCardIndex];
        if (propositionId) {
          await this.showMapCard(propositionId, false);
        }
      }
    }
  },

  created() {
    window.prerenderPaused = true;

    setTimeout(() => {
      if (this.isMobile) this.temporaryHideTrialBanner({ hide: true });
    }, 100);
  },

  destroyed() {
    this.scrollToTop(true);
  },

  async mounted() {
    window.addEventListener('scroll', this.onScroll);

    if (this.isMobile) this.temporaryHideTrialBanner({ hide: true });

    try {
      window.addEventListener('popstate', this.handlePopstateChange);

      this.removeFixedHeaderPatch();

      await this.loadSavedState();

      if (!this.appReady) await this.initAppData();

      if (this.isAuthenticated) {
        this.fetchFavourites();
        if (!this.searchViewVisible) {
          this.fetchCoverages();
        }
      }

      //this.showMobileHeader(false);

      this.isIosDevice = !!navigator.userAgent.match(/iPhone|iPod|iPad/);
    } catch (error) {
      this.firstLoadDone = true;
      throw new Error(error);
    }

    this.firstLoadDone = true;

    if (
      !this.sponsoredPropositions ||
      this.sponsoredPropositions.length === 0
    ) {
      this.getSponsoredPropositions();
    }

    events.emitEvent(events.eventTypes.PAGEVIEW, 'Search');
  },

  beforeDestroy() {
    window.removeEventListener('scroll', this.onScroll);
    this.temporaryHideTrialBanner({ hide: false });
    window.removeEventListener('popstate', this.handlePopstateChange);
    this.showMobileHeader(true);
  },

  methods: {
    handleFilterBarSearch(config) {
      this.handleSearch({ skipDebounce: true, map: null, ...config });
    },
    setBodyActive(active) {
      if (active) {
        this.setSearchBottomBar(true);
      } else {
        this.scrollToCallback(0.0, () => {
          this.isMapOutOfViewPort = false;
          this.setSearchBottomBar(false);
        });
      }
    },
    scrollToCallback(offset, callback) {
      const fixedOffset = offset.toFixed();
      const onScroll = function () {
        if (window.pageYOffset.toFixed() === fixedOffset) {
          window.removeEventListener('scroll', onScroll);
          callback();
        }
      };

      window.addEventListener('scroll', onScroll);
      onScroll();
      window.scrollTo({
        top: offset,
        behavior: 'smooth'
      });
    },
    onScroll() {
      this.windowTop = window.top.scrollY;
    },

    async handlePopstateChange() {
      await this.getQueryFilterAndSetToState();
      await this.handleSearch();
    },

    handleFiltersClick() {
      this.isFilterVisible = true;
      this.showMobileHeader(false);
    },

    async searchSpecificArea(eventData) {
      this.setRootFilter({
        fromMapInteraction: false
      });

      if (
        !this.isTypeResidence &&
        eventData.geolocations &&
        eventData.geolocations[0]
      ) {
        const relatedLocalities = await getRelatedLocalities(
          eventData.geolocations[0].id
        );

        eventData.geolocations = relatedLocalities.map(id => ({
          id: id
        }));
      }

      this.setFilter({
        geolocations: eventData.geolocations,
        freetext: eventData.freetext || null,
        geolocationsSource: eventData.geolocationsSource || null
      });

      this.handleSearch({ skipAreaSearch: true });
    },

    removeFixedHeaderPatch() {
      const elements = document.getElementsByClassName('static-header');

      if (elements) {
        [...elements].forEach(el => el.classList.remove('fixed-header'));
      }
    },
    getNextPageNumber() {
      let page = this.$router.currentRoute.query?.page;
      if (page) {
        page = page.replace(/[^0-9]/g, '');
      }

      let newPage;

      if (page) {
        newPage = Number(page) + 1;
      } else {
        newPage = this.data && this.data.meta ? this.data.meta.page + 1 : 2;
      }

      if (
        (this.data && this.data.meta && this.data.meta.numPages >= newPage) ||
        !this.data
      ) {
        return newPage;
      } else {
        return 2;
      }
    },

    getPrevPageNumber() {
      let page = this.$router.currentRoute.query.page;
      if (page) {
        page = page.replace(/[^0-9]/g, '');
      }

      let newPage;

      if (page) {
        newPage = Number(page) - 1;
      } else {
        newPage = this.data && this.data.meta ? this.data.meta.page - 1 : 1;
      }

      if (newPage >= 1) {
        return newPage;
      } else {
        return 1;
      }
    },

    createCoverageClick() {
      if (this.isAuthenticated) {
        this.coverageConfirmVisible = true;
      } else {
        this.loginConverterMessage = this.$t(
          'search_coverage_not_logged_in',
          this.$routeLocale
        );
        this.loginConverterVisible = true;
      }
    },

    handleMarkerHover(fullEvent) {
      if (fullEvent && fullEvent.point) this.markedItemId = fullEvent.point.id;
    },

    hideFilters() {
      this.isFilterVisible = false;
      this.showMobileHeader(true);
    },

    handleListViewSwitch(event) {
      this.listViewSwitcherActive = event.isActive;
      localStorage.setItem(
        'listViewSwitcherActive',
        this.listViewSwitcherActive
      );

      // Trigger resize event for map to change size
      this.$nextTick(() => {
        window.dispatchEvent(new Event('resize'));
      });
    },

    hideMapCard() {
      this.showMapCardModal = false;
      this.markedItemId = null;
      this.highlightedMarkerPointId = null;
    },

    handleMarkerClicked(fullEvent) {
      this.hideMapCard();
      this.currentMapCardIndex = 0;
      if (!fullEvent) {
        return;
      }

      this.currentMapCardIds = fullEvent.propositionIds;

      this.showMapCard(this.currentMapCardIds[0]);
    },

    showPreviousMapCard() {
      const newIndex = this.currentMapCardIndex - 1;
      if (newIndex >= 0) {
        this.currentMapCardIndex = newIndex;
      } else {
        this.currentMapCardIndex = this.currentMapCardIds.length - 1;
      }
    },

    showNextMapCard() {
      const newIndex = this.currentMapCardIndex + 1;
      if (newIndex <= this.currentMapCardIds.length - 1) {
        this.currentMapCardIndex = newIndex;
      } else {
        this.currentMapCardIndex = 0;
      }
    },

    async showMapCard(propositionId, updateHighlightedMarker = true) {
      this.showMapCardModal = true;
      this.mapCardItemLoading = true;
      this.markedItemId = propositionId;
      if (updateHighlightedMarker) {
        this.highlightedMarkerPointId = propositionId;
      }

      const foundProposition = this.data.results.find(
        x => x.propositionId === this.markedItemId
      );

      if (foundProposition) {
        this.mapCardItem = foundProposition;
        this.mapCardItemLoading = false;

        return;
      }

      try {
        const searchResponse = await getSearchProposition(propositionId);
        const proposition = searchResponse.data;

        if (proposition) {
          this.mapCardItem = proposition;
        }
      } catch (error) {
        // Empty catch block
      }

      this.mapCardItemLoading = false;
    },

    triggerPropositionClickedEvent(event) {
      events.emitEvent(events.eventTypes.CLICK, 'View Proposition', {
        src: this.mapCardItem ? 'search-map' : 'search-result',
        propositionId: event
      });
    },

    handlePropositionCardRightClick(event, mapClick = false) {
      console.log('test');
      addRightClickTracker(event, mapClick ? 'search-map' : 'search-result');
    },

    handlePropositionClick(event) {
      try {
        localStorage.setItem('searchData', JSON.stringify(this.data));

        let scroll = window.scrollY;

        if (!this.isMobile) {
          scroll = document.getElementById('results').scrollTop;
        }

        localStorage.setItem('scrollTop', scroll);

        if (this.mapCardItem) {
          localStorage.setItem('mapCardItem', JSON.stringify(this.mapCardItem));
          this.triggerPropositionClickedEvent(event, true);
        } else {
          this.triggerPropositionClickedEvent(event);
        }
      } catch (error) {
        console.error('Could not add to localstorage');
      }
    },

    setSearchViewVisible(visible) {
      if (this.searchViewVisible !== visible) this.searchViewVisible = visible;

      // Trigger resize event for map to change size
      this.$nextTick(() => {
        setTimeout(() => {
          if (visible) this.scrollToTop();
        }, 300);

        window.dispatchEvent(new Event('resize'));
      });

      if (!this.coverageData && this.isAuthenticated) {
        this.fetchCoverages();
      }

      localStorage.setItem('searchViewVisible', this.searchViewVisible);
    },

    handleOrder(orderValue) {
      if (!orderValue) {
        this.setRootFilter({ orderBy: [], page: 1 });
      } else {
        const splitted = orderValue.split('_');
        const order = splitted[0];
        const desc = splitted[1] !== 'asc';
        this.setRootFilter({ orderBy: [{ key: order, desc: desc }], page: 1 });
      }

      this.handleSearch();
    },

    hideLoginbox(e) {
      e.preventDefault();
      e.stopPropagation();

      this.loginConverterVisible = false;
    },

    async handleMapReady() {
      this.mapReady = true;
      await this.search();
      this.isFirstSearchDone = true;
    },

    handleHover(proposition) {
      if (proposition) this.highlightedMarkerPointId = proposition.pointId;
      else this.highlightedMarkerPointId = null;
    },

    handleLike() {
      this.loginConverterMessage = this.$t(
        'search_favorite_not_logged_in',
        this.$routeLocale
      );

      if (!this.isAuthenticated) this.loginConverterVisible = true;
    },

    async handleAddCoverage() {
      this.addCoverageCode = -1;
      this.addingCoverage = true;

      const result = await this.addCoverage(this.rootFilter);
      this.addCoverageCode = result;
      this.coverageConfirmVisible = true;
      this.addingCoverage = false;

      if (this.addCoverageCode != -1) {
        setTimeout(() => {
          this.coverageConfirmVisible = false;
          this.addCoverageCode = -1;
        }, 2500);
      }
    },

    async loadNextPage() {
      if (this.data.meta.numPages > this.data.meta.page) {
        this.setRootFilter({
          page: this.getNextPageNumber()
        });

        if (this.$router.currentRoute.query.page)
          delete this.$router.currentRoute.query.page;

        this.isLoadingNextPage = true;
        await this.search({ merge: true });
        this.isLoadingNextPage = false;
      }
    },

    async loadSavedState() {
      const searchViewVisible = localStorage.getItem('searchViewVisible');
      if (searchViewVisible !== null && searchViewVisible !== undefined)
        this.searchViewVisible = JSON.parse(searchViewVisible.toLowerCase());

      const listViewSwitcherActive = localStorage.getItem(
        'listViewSwitcherActive'
      );
      if (
        listViewSwitcherActive !== null &&
        listViewSwitcherActive !== undefined
      ) {
        this.listViewSwitcherActive = JSON.parse(
          listViewSwitcherActive.toLowerCase()
        );
      }

      const mapCardItem = localStorage.getItem('mapCardItem');
      if (mapCardItem) {
        localStorage.removeItem('mapCardItem');
        this.mapCardItem = JSON.parse(mapCardItem);
      }

      if (this.$router.currentRoute.query.filter) {
        await this.getQueryFilterAndSetToState();
      }
    },

    toggleArrayItem,
    ...mapMutations({
      setItem: 'search/setItem',
      setRootFilter: 'search/setRootFilter',
      setFilter: 'search/setFilter',
      setLoading: 'search/setLoading',
      setData: 'search/setData',
      setSearchBottomBar: 'search/setSearchBottomBar'
    }),

    ...mapActions({
      showMobileHeader: 'ui/showMobileHeader',
      temporaryHideTrialBanner: 'trial/temporaryHideTrialBanner',
      initAppData: 'app/initAppData',
      deleteCoverage: 'search/deleteCoverage',
      fetchFavourites: 'favourites/fetchFavourites',
      fetchSearch: 'search/fetchSearch',
      resetFilter: 'search/resetFilter',
      getQueryFilterAndSetToState: 'search/getQueryFilterAndSetToState',
      fetchCoverages: 'search/fetchCoverages',
      addCoverage: 'search/addCoverage',
      getAndSetGeolocationsFromFilter: 'search/getAndSetGeolocationsFromFilter',
      getSponsoredPropositions: 'propositions/getSponsoredPropositions'
    }),

    scrollToTop(skipSmooth) {
      this.$nextTick(() => {
        if (this.isMobile) {
          window.scrollTo({ top: 0, behavior: skipSmooth ? 'auto' : 'smooth' });
        } else {
          const results = document.getElementById('results');
          results?.scrollTo({
            top: 0,
            behavior: skipSmooth ? 'auto' : 'smooth'
          });
        }
      });
    },

    scrollToResults() {
      this.$nextTick(() => {
        window.scrollTo({ top: window.innerHeight, behavior: 'smooth' });
      });
    },

    scrollToElement() {
      const offset = this.isMobile && !this.isAuthenticated ? 50 : 0;
      this.$nextTick(() => {
        const el = document.getElementById('results');
        scrollToElement(el, offset);
      });
    },

    async search(config) {
      await this.fetchSearch({
        rootFilter: this.rootFilter,
        ...config
      });
    },

    async handleSearch(config = {}) {
      let waitTime = 500;

      if (config.skipDebounce) {
        waitTime = 0;
      }

      if (config.skipAreaSearch) {
        this.setRootFilter({
          map: null,
          searchArea: null
        });
      }

      if (this.searchingTimerId) clearTimeout(this.searchingTimerId);

      this.isSearching = true;

      this.searchingTimerId = setTimeout(async () => {
        localStorage.removeItem('searchData');
        if (!this.searchViewVisible) this.setSearchViewVisible(true);

        this.setRootFilter({
          page: 1
        });

        await this.search(config);
        if (config?.scrollToTop) {
          this.scrollToTop();
        }

        this.isSearching = false;

        if (this.rootFilter.type === 'wish') {
          events.emitEvent(events.eventTypes.CLICK, 'Search Wish');
        } else {
          events.emitEvent(events.eventTypes.CLICK, 'Search Residence');
        }
      }, waitTime);
    },

    async handleCoverageClick(coverage) {
      this.setSearchViewVisible(true);

      this.setData(null);

      const searchFilter = convertToSearchFilter(coverage);

      this.setRootFilter(searchFilter);
      this.handleSearch({ skipDebounce: true });
    },

    async handleDeleteCoverage(coverageId) {
      this.deletingCoverage = true;

      try {
        await this.deleteCoverage(coverageId);
      } catch (error) {
        console.error(error);
      }

      this.deletingCoverage = false;
    }
  }
};
</script>

<style lang="scss" scoped>
$filterWidth: 400px;

.text-center {
  text-align: center;
}

.sort-text {
  color: $transfer-blue;
  margin-top: 15px;
}

.search-results {
  @media ($mobile) {
    padding: 15px;
    height: 100%;
    overflow: hidden;
  }
}

.margin-bottom-fix {
  @media ($mobile) {
    margin-bottom: 45px;
  }
}

.confirm-box {
  position: fixed;
  z-index: 99;
  max-width: 350px;
  top: calc(50% - 100px);
  left: calc(50% - 175px);
}

.hero {
  width: 100%;
  flex-direction: column;
  margin-bottom: 50px;
  font-size: 2em;
  font-weight: bold;
}

.large-page-spinner-wrapper {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 40px;
  padding-bottom: 40px;

  @media ($mobile) {
    padding-top: 5px;
    padding-bottom: 75px;
  }
}

.large-page-spinner-wrapper .spinner {
  width: 40px;
  height: 40px;
}

.next-page-spinner {
  border-top-color: $main_blue !important;
}

.no-hits {
  padding: 5px;
  text-align: center;

  margin-top: 25px;

  @media ($mobile) {
    margin-bottom: 70px;
  }
}

.results {
  @media ($desktop) {
    padding: 0 15px;
    width: 100%;
    position: relative;
  }
}

.title {
  margin-left: 20px;
  margin-bottom: 20px;

  @media ($mobile) {
    font-size: 22px;
  }
}

.content {
  max-width: 100% !important;
  width: 100% !important;

  @media ($desktop) {
    padding-top: 80px !important;
  }
}

.full-height {
  height: 100vh;
}

.full-width {
  width: 100%;
}

.mgr-10 {
  margin-right: 10px;
}

.mgt-25 {
  margin-top: 25px;
}

.mgt-10 {
  margin-top: 10px;
}

.mgb-10 {
  margin-bottom: 10px;
}

.mgb-25 {
  margin-bottom: 25px;
}

p {
  margin: 0;
}

h2 {
  font-size: 24px;
  font-weight: 700;
}

.ribbon {
  @media ($mobile) {
    z-index: 10;
    display: flex;
    position: fixed;
    bottom: 0px;
    left: 0;
    height: 70px;
    width: 100%;
    background: rgba(241, 242, 246, 0.8);
    backdrop-filter: blur(4px);
  }

  @media ($desktop) {
    display: flex;
    position: relative;
  }
}

.ribbon > .ribbon-content {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 25px;

  @media ($desktop) {
    padding: 25px 25px;
    height: 100%;
  }
}

.ribbon-authenticated {
  @media ($mobile) {
    bottom: 95px;
  }
}

.ribbon-content > * {
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 23px;
  letter-spacing: 0.05em;
  color: $main-blue;
}

.wrapper-content {
  display: flex;
  flex-flow: column;
  flex-wrap: wrap;

  @media ($desktop) {
    flex-flow: row;
  }
}

.filters-wrapper {
  padding: 15px;
  width: 100%;

  @media ($mobile) {
    overflow: scroll;
    margin-bottom: 195px;

    .is-not-authenticated & {
      margin-bottom: 100px;
    }
  }
}

.search-info-box {
  display: flex;
  flex-flow: column;

  @media ($desktop) {
    margin-bottom: 10px;
  }

  @media ($mobile) {
    padding: 20px;
    // background-color: $form-background-dark;
  }
}

.text-center {
  text-align: center;
}

.text-danger {
  color: $sweet-red;
}

hr {
  border: none;
}

h2 {
  margin: 0;
  padding: 0;
}

.view-selector-all-wrapper {
  width: 82px;
}

::v-deep .view-selector-wrapper {
  background-color: #e8e8e8;
}

.wrapper-content-base {
  display: flex;
  flex-direction: row;
  padding: 0;
  height: 100vh;
  overflow: hidden;

  @media ($mobile) {
    flex-direction: column;
    position: fixed;
    top: $mobile-static-header;
    height: auto;
    left: 0;
    bottom: 0;
    right: 0;
    &.active {
      position: static;
      height: calc(100vh - $mobile-static-header);
    }
  }
}

.wrapper-content-base.trial-banner-open {
  height: calc(100vh - 103px);
}

.relative {
  position: relative;
}

.column {
  display: flex;
  align-content: center;
  justify-content: center;
  height: 100%;

  @media ($desktop) {
    overflow-x: auto;
    scrollbar-gutter: stable;
  }

  @media ($mobile) {
    flex-direction: column;
    position: relative;
  }
}

.left {
  min-width: 350px;
  max-width: 350px;

  @media ($mobile) {
    display: none;
  }
}

.middle {
  width: 530px;

  @media ($desktop) {
    padding-top: 20px;
  }

  @media ($mobile) {
    flex-grow: 1;
    padding-top: 20px;
    order: 2;
    position: relative;
    width: 100%;
  }
}

.middle.authenticated {
  @media ($mobile) {
    padding-bottom: 95px;
  }
}

.coverage {
  min-width: 600px;
  max-width: 750px;
  overflow-y: scroll;
  overflow-x: hidden;

  @media ($mobile) {
    min-width: 335px;
  }
}

.search-coverage-close {
  display: flex;
  justify-content: center;
  margin-top: 50px;
}

.search-coverage-close-button {
  @media ($desktop) {
    margin-bottom: 50px;
  }
}

.right {
  flex-grow: 1;
  scrollbar-gutter: initial;

  @media ($mobile) {
    display: flex;
    flex-direction: row;

    order: 1;
  }
}

.mgt-80 {
  margin-top: 80px;
}

.full-panel {
  position: fixed;
  height: 100%;
  width: 280px;
  z-index: 999;
  background-color: white;

  display: flex;
  flex-direction: column;
  align-content: flex-start;
  justify-content: flex-start;
  align-items: center;
  top: 0;
  @media ($mobile) {
    width: 100%;
  }
}

.filter-panel-bar {
  padding: 20px;
  position: absolute;
  bottom: 0px;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  background-color: white;
  margin-bottom: env(safe-area-inset-bottom);

  @media ($mobile) {
    bottom: 95px;
    height: 100px;
    display: flex;
    justify-content: center;
    align-items: center;
    box-shadow: 0px -2px 32px 0px rgba(0, 0, 0, 0.27);

    .is-not-authenticated & {
      bottom: 0;
    }
  }
}

.row {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
}

.show-map-wrapper {
  display: flex;
  position: fixed;
  bottom: 35px;
  padding-bottom: env(safe-area-inset-bottom);
  flex-wrap: nowrap;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  z-index: 999;
  width: 100%;
}

.show-map-wrapper.authenticated {
  bottom: 75px;
}

.geolocation-wrapper-mobile {
  position: absolute;
  width: 100%;
  padding: 10px 20px;
  top: 0;
  z-index: 3;
  transition: background-color 0.1s;

  &.is-fixed {
    position: fixed;
    top: 0;
    background-color: #fff;
    border-bottom: 1px solid #f1f2f6;
  }
}

.filter-info {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 24px;
  width: 24px;
  font-size: 14px;
  font-weight: 600;
}

.filter-info-wrapper {
  border-radius: 50%;
  color: white;
  background-color: #409fff;
  margin-left: 8px;
}

.icon {
  display: inline-flex;
  height: 18px;
  width: 18px;
  background-position: center;
  background-size: contain;
}

.icon-wrapper {
  margin-left: 8px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.icon-wrapper-left {
  margin: 0px;
  margin-right: 8px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.map-card-item {
  position: absolute;
  bottom: 10px;
  min-height: 265px;
  width: 350px;
  padding-bottom: env(safe-area-inset-bottom);
  border-radius: 10px;
  overflow: hidden;
  z-index: 2;

  @media ($mobile) {
    bottom: 35px;
    .authenticated & {
      bottom: 72px;
    }
  }
}

// .spinner-wrapper {
//   display: inline-block;
//   width: 40px;
//   height: 40px;
// }

.left-panel {
  position: absolute;
  background-color: white;
  z-index: 5;
  width: 360px;
  box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.25);
}

.floating-button {
  position: fixed;
  z-index: 99;
  bottom: 45px;
  right: 45px;
}

.drag-panel-top {
  top: 0;
  border-radius: 20px 20px 0 0;
  cursor: grabbing;
  width: 100%;
  padding: 12px 0 22px;
  box-shadow: 0 -4px 10px rgb(0 0 0 / 10%);
  position: absolute;
  background-color: #fff;
  z-index: 1;
  transform: translateY(-100%);
  &-icon {
    display: flex;
    justify-content: center;
    width: 100%;
    margin-bottom: 17px;
  }
  &-title {
    font-size: 15px;
    margin: 0;
    text-align: center;
  }
}

.sponsored-propositions {
  @media ($mobile) {
    margin-left: -15px;
  }
}

.mapboxgl-map > a > img {
  display: none !important;
}

.select-wrapper {
  border-radius: 10px;
  display: inline-flex;
  overflow: hidden;
  background: #ffffff;
  border: 1px solid #e8e8e8;
}

.select-wrapper > div {
  margin-right: 17px;
}

.select-wrapper select {
  max-width: 190px;
  font-weight: 600;
  color: $text-primary;
  font-size: 14px;
  line-height: 18px;
}

select {
  outline: none;
  height: 40px;
  border: 0px;
  background: #ffffff;
  padding: 10px 35px 10px 20px;
  cursor: pointer;

  -moz-appearance: none;
  -webkit-appearance: none;
  appearance: none;
  background: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTEiIGhlaWdodD0iNyIgdmlld0JveD0iMCAwIDExIDciIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0xMC4yNDU4IDAuMjkwNzkyQzEwLjA1ODQgMC4xMDQ1NDIgOS44MDQ5OCAwIDkuNTQwOCAwQzkuMjc2NjEgMCA5LjAyMzE2IDAuMTA0NTQyIDguODM1OCAwLjI5MDc5Mkw1LjI0NTggMy44MzA3OUwxLjcwNTggMC4yOTA3OTJDMS41MTg0NCAwLjEwNDU0MiAxLjI2NDk4IDAgMS4wMDA4IDBDMC43MzY2MTIgMCAwLjQ4MzE2MSAwLjEwNDU0MiAwLjI5NTc5OCAwLjI5MDc5MkMwLjIwMjA3IDAuMzgzNzU1IDAuMTI3Njc1IDAuNDk0MzU2IDAuMDc2OTA2NyAwLjYxNjIxNkMwLjAyNjEzOCAwLjczODA3NSAwIDAuODY4NzgxIDAgMS4wMDA3OUMwIDEuMTMyOCAwLjAyNjEzOCAxLjI2MzUxIDAuMDc2OTA2NyAxLjM4NTM3QzAuMTI3Njc1IDEuNTA3MjMgMC4yMDIwNyAxLjYxNzgzIDAuMjk1Nzk4IDEuNzEwNzlMNC41MzU4IDUuOTUwNzlDNC42Mjg3NiA2LjA0NDUyIDQuNzM5MzYgNi4xMTg5MSA0Ljg2MTIyIDYuMTY5NjhDNC45ODMwOCA2LjIyMDQ1IDUuMTEzNzkgNi4yNDY1OSA1LjI0NTggNi4yNDY1OUM1LjM3NzgxIDYuMjQ2NTkgNS41MDg1MiA2LjIyMDQ1IDUuNjMwMzcgNi4xNjk2OEM1Ljc1MjIzIDYuMTE4OTEgNS44NjI4NCA2LjA0NDUyIDUuOTU1OCA1Ljk1MDc5TDEwLjI0NTggMS43MTA3OUMxMC4zMzk1IDEuNjE3ODMgMTAuNDEzOSAxLjUwNzIzIDEwLjQ2NDcgMS4zODUzN0MxMC41MTU1IDEuMjYzNTEgMTAuNTQxNiAxLjEzMjggMTAuNTQxNiAxLjAwMDc5QzEwLjU0MTYgMC44Njg3ODEgMTAuNTE1NSAwLjczODA3NSAxMC40NjQ3IDAuNjE2MjE2QzEwLjQxMzkgMC40OTQzNTYgMTAuMzM5NSAwLjM4Mzc1NSAxMC4yNDU4IDAuMjkwNzkyWiIgZmlsbD0iIzJDM0U1MCIvPgo8L3N2Zz4KCg==)
    no-repeat 90% 55%;
}

.proposition-popup {
  position: absolute;
  width: 335px;
  height: 265px;
  top: -300px;
  left: -160px;
  background-color: yellow;
}

.pulled-right {
  display: flex;
  justify-content: center;
}

.filter-toggle-button {
  display: grid;
  place-items: center;
  padding: 12px;
  border: 1px solid #e8e8e8;
  border-radius: 10px;
  cursor: pointer;

  img {
    width: 16px;
    height: 16px;
  }
}

.map-card-item-controls {
  background-color: #fff;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  display: flex;
  align-items: center;
  overflow: hidden;
  justify-content: space-between;
  height: 50px;
  border-top: 1px solid #f1f2f6;

  .map-card-item-controls-text,
  .map-card-item-button {
    text-align: center;
  }

  .map-card-item-controls-text {
    font-size: 14px;
    font-weight: 600;
  }

  .map-card-item-button {
    border: none;
    cursor: pointer;
    height: 2.6rem;
    width: 2.6rem;
    background: #fff;
    box-shadow: none;
    padding: 6px;

    span {
      height: 50%;
      width: 50%;
      display: block;
      background: url('../../../assets/svg/arrow-down-black.svg') no-repeat
        center;
      background-size: contain;
      margin: 0 auto;
    }

    &.point-left span {
      transform: rotate(90deg);
    }

    &.point-right span {
      transform: rotate(-90deg);
    }
  }
}

.results-wrapper {
  @media ($mobile) {
    position: absolute;
    bottom: 0;
    background: #fff;
    left: 0;
    width: 100%;
    transform: translateY(100%);
    padding: 0;
    z-index: 2;
    &.tabBarVisible {
      transform: translateY(calc(100% - 95px));
    }
  }
}

.results {
  @media ($mobile) {
    background-color: #fff;
  }
}
</style>
<style lang="scss">
.map-card-item-with-controls .proposition-picker-wrapper {
  border-radius: 0;
  margin-top: 0;
}

.map-card-item-with-controls .item-wrapper {
  border: 0;
  border-radius: 0;
  margin-top: 0;
}
</style>
